export default "__VITE_ASSET__BhqAcIyf__"